import { useMemo } from "react";
import useYMMTLabels from "./useYMMTLabels";

const setCookie = (name, value) =>
  name && value ? (document.cookie = `${name}=${value}`) : undefined;

const useSetCookies = (ymmtIds = {}) => {
  const [[year, make, model, trim]] = useYMMTLabels(ymmtIds);

  useMemo(() => {
    setCookie("trade_year", year);
    setCookie("trade_make", make);
    setCookie("trade_model", model);
    setCookie("trade_trim", trim);
  }, [year, make, model, trim]);
};

export default useSetCookies;
